import { useEffect, useRef } from 'react';
import PWChangePopup from './System/Popup/PWChangePopup';
import useAuth from '@maxis/client-logic/hooks/useAuth';
import { useBoundStore } from '@maxis/client-logic/index';
import { Button } from '@maxis/components/components';
import style from './PasswordChange.module.css';
function PasswordChange() {
    const popupRef = useRef();
    const { logout } = useAuth();
    const user = useBoundStore((state) => state.user);
    // useEffect(() => {
    //     setTimeout(() => {
    //         popupRef.current?.showPopup();
    //     }, 1000);
    // }, []);

    return (
        <div className={style.container}>
            <h2>비밀번호 재설정 안내</h2>
            <span>서비스 이용을 위해 비밀번호를 변경해 주세요.</span>
            <div className={style.buttons}>
                <Button
                    label={'비밀번호 변경'}
                    checkAuth={false}
                    onClick={() => {
                        popupRef.current?.showPopup();
                    }}
                    colorType={'main'}
                />
                <Button
                    label={'로그아웃'}
                    checkAuth={false}
                    onClick={() => {
                        logout(user?.userId);
                    }}
                />
            </div>

            <PWChangePopup ref={popupRef} />
        </div>
    );
}
export default PasswordChange;
